module.exports = __webpack_public_path__ + "img/logo.4bf6007b.png";